import { render, staticRenderFns } from "./TrickQuestion.vue?vue&type=template&id=71d8ce60&"
import script from "./TrickQuestion.vue?vue&type=script&lang=ts&"
export * from "./TrickQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports